// User entity query keys (per §11.4 entity-user-queries sub-task 1).
//
// `users.current` namespaces the authenticated user; `users.options`
// namespaces the search-only owner picker the settings UI uses.

import { queryRoots, type QueryKey } from '@/shared/query';

export const userKeys = {
  all: (): QueryKey => [queryRoots.users],
  current: (): QueryKey => [queryRoots.users, 'current'],
  options: (search: string): QueryKey => [queryRoots.users, 'options', search],
} as const;
